module.exports = __webpack_public_path__ + "static/media/vr.a4b7efa8.png";